import type { ColDef } from 'ag-grid-community';

const colDef: ColDef[] = [
  {
    headerName: '',
    colId: 'actions',
    cellRenderer: 'undoDeletedCondition',
    editable: false,
    filter: false,
    pinned: 'left',
    suppressMenu: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    width: 90
  },
  {
    field: 'customer',
    headerName: '需要家',
    headerTooltip:'需要家',
    maxWidth: 150,
  },
  {
    field: 'customerName',
    headerName: '需要家名',
    headerTooltip:'需要家名',
  },
  {
    field: 'deliveryLocation',
    headerName: '受渡場所',
    headerTooltip:'受渡場所',
    maxWidth: 150,
  },
  {
    field: 'deliveryLocationName',
    headerName: '受渡場所名',
    headerTooltip:'受渡場所名',
  },
];

export default colDef;